// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qszf","col":"styles_col__grl2c","actions":"styles_actions__lB2yc","conflict":"styles_conflict__B4tdb"};